import posthogClient from 'posthog-js'
import { isPublicScreen } from './lib/publicScreens'
import { scrubDecideTokens } from './sentry'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_POSTHOG_HOST
const posthogEnabled = Boolean(posthogKey && posthogHost && !isPublicScreen(window.location.pathname))
const posthog = posthogClient

if (!posthogKey) {
    if (import.meta.env.DEV) {
        console.error(
            new Error(
                'VITE_POSTHOG_KEY variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_KEY is configured',
            ),
        )
    }
} else if (posthogEnabled) {
    posthog.init(posthogKey, {
        api_host: posthogHost,
        defaults: '2026-08-30',
        capture_pageview: 'history_change',
        before_send: event => {
            if (isPublicScreen(window.location.pathname)) return null
            return scrubDecideTokens(event)
        },
        // Replay payloads can retain credential-bearing navigation URLs outside before_send.
        disable_session_recording: true,
        logs: {
            serviceName: 'zerohuman-portal',
            environment: import.meta.env.MODE,
        },
        capture_exceptions: {
            capture_unhandled_errors: true,
            capture_unhandled_rejections: true,
            capture_console_errors: false,
        },
    })
} else if (!posthogHost && import.meta.env.DEV) {
    console.error(
        new Error(
            'VITE_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once VITE_POSTHOG_HOST is configured',
        ),
    )
}

export { posthog, posthogEnabled }
